import api from "../../api/axios";
import { CreateIntegrationData, Integration, IntegrationType } from "./types";

export const getIntegrations = async (params: {
  skip: number;
  take: number;
  agent_id?: string;
}): Promise<{ items: Integration[]; total: number }> => {
  const response = await api.get("/integrations", { params });
  return response.data;
};

export const getIntegration = async (id: string): Promise<Integration> => {
  const response = await api.get(`/integrations/${id}`);
  return response.data;
};

export const createIntegration = async (
  data: CreateIntegrationData
): Promise<Integration> => {
  const response = await api.post("/integrations", data);
  return response.data;
};

export const updateIntegration = async (
  id: string,
  data: Partial<Omit<Integration, "id" | "createdAt" | "updatedAt">>
): Promise<Integration> => {
  const response = await api.put(`/integrations/${id}`, data);
  return response.data;
};

export const deleteIntegration = async (id: string): Promise<void> => {
  await api.delete(`/integrations/${id}`);
};

export const getIntegrationTypes = async (): Promise<IntegrationType[]> => {
  const response = await api.get("/integrations/types");
  return response.data;
};

export const testIntegrationConnectivity = async (payload: {
  integration_type_id: string;
  configurations: Record<string, any>;
}): Promise<{ success: boolean; message: string }> => {
  const response = await api.post("/integrations/test", payload);
  return response.data;
};
